import { createSlice } from "@reduxjs/toolkit";
import { updateFollowUpStatus } from "../inquiry/services/inquiry.services";

interface IDashboardState {
  loading: boolean;
  followUpLoading: boolean;
  error: string;
  followupId: number | null;
}

const initialState: IDashboardState = {
  loading: false,
  followUpLoading: false,
  error: "",
  followupId: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearFolloupID: (state) => {
      state.followupId = initialState.followupId;
    },
    setFolloupID: (state, action) => {
      state.followupId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateFollowUpStatus.pending, (state) => {
      state.followUpLoading = true;
      state.error = "";
    });
    builder.addCase(updateFollowUpStatus.fulfilled, (state) => {
      state.followUpLoading = false;
    });
    builder.addCase(updateFollowUpStatus.rejected, (state, action) => {
      state.followUpLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearFolloupID, setFolloupID } = dashboardSlice.actions;
export default dashboardSlice.reducer;
